import React from 'react';
import PropTypes from 'prop-types';
import { withBrand } from '../../../providers/BrandProvider';
import CallToAction from '../../shared/CallToAction/CallToAction';
import './PersonFooter.scss';

export function PersonFooter(props) {
  const {
    title,
    description,
    brand = {},
    isCourse = false,
    liveAgenda = false,
  } = props;

  return (
    <section
      className="c-event-section c-person-footer-section"
      style={{ backgroundColor: brand.darkSecondaryColor }}
    >
      <div className="container">
        {!isCourse && (
          <div className="row">
            <div className="col-xs-12">
              <h2 className="c-event-section__heading c-event-section__heading--tiny-margin text-center">
                {title}
              </h2>
              {description && <p className="text-center">{description}</p>}
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xs-12">
            <div
              className={`c-event-section__cta ${
                isCourse ? 'c-event-section__course-cta' : ''
              }`}
            >
              <div className="text-center">
                <CallToAction ctaConfig={{ type: 'BUY_LINK' }} />
                {liveAgenda && (
                  <CallToAction ctaConfig={{ type: 'AGENDA_LINK_SHORT' }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

PersonFooter.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  brand: PropTypes.object,
  isCourse: PropTypes.bool,
  liveAgenda: PropTypes.bool,
};

export default withBrand(PersonFooter);
